import {
  getPendingBalance,
  hasPendingItems,
  hasScheduledItems
} from "./planQueuePresentation"

export function buildFilteredPlans({
  plans,
  effectivePatientId,
  statusFilter,
  financialFilter,
  quickFilter
}) {
  let rows = [...plans]

  if (effectivePatientId) {
    rows = rows.filter((plan) => String(plan.patientId || "") === String(effectivePatientId))
  }

  if (statusFilter !== "ALL") {
    rows = rows.filter(
      (plan) => String(plan.status || "").toUpperCase() === statusFilter
    )
  }

  if (financialFilter !== "ALL") {
    rows = rows.filter((plan) => {
      const pending = getPendingBalance(plan)

      if (financialFilter === "WITH_BALANCE") return pending > 0
      if (financialFilter === "WITHOUT_BALANCE") return pending <= 0
      return true
    })
  }

  if (quickFilter !== "ALL") {
    rows = rows.filter((plan) => {
      const status = String(plan.status || "").toUpperCase()
      const items = Array.isArray(plan.items) ? plan.items : []
      const pendingBalance = getPendingBalance(plan)
      const hasPending = hasPendingItems(plan)
      const hasScheduled = hasScheduledItems(plan)

      if (quickFilter === "REQUIRES_ACTION") {
        return status === "ACTIVE" && (hasPending || pendingBalance > 0)
      }

      if (quickFilter === "WITHOUT_APPOINTMENT") {
        return status === "ACTIVE" && items.length > 0 && !hasScheduled
      }

      if (quickFilter === "WITH_PENDING_ITEMS") {
        return hasPending
      }

      if (quickFilter === "WITH_BALANCE") {
        return pendingBalance > 0
      }

      return true
    })
  }

  return rows
}

export function resolveCurrentPatientMeta({
  patients,
  filteredPlans,
  effectivePatientId
}) {
  const fromPatients =
    patients.find((item) => String(item.id) === String(effectivePatientId)) || null

  if (fromPatients) return fromPatients

  const fromPlans =
    filteredPlans.find((plan) => String(plan.patientId || "") === String(effectivePatientId))
      ?.patient || null

  return fromPlans
}